export class CollapseDesignerAction {
  static type = 'designer/COLLAPSE';
  constructor() {
    this.type = CollapseDesignerAction.type;
  }
}
